export default {
  route: 'Route',
  vehicle: 'Vehicle',
  assignment: 'Assignments',
  work: 'Work',
  break: 'Break',
  dailyTotal: 'Daily Total',
  sameStartEnd: "Start and end times can't be the same.",
  editAssignment: 'Edit Assignment',
  repeat: 'Repeat',
  handoverLocation: 'Handover Location',
  addBreak: 'Add Break',
  breakStart: 'Break Start',
  breakEnd: 'Break End',
  breakDuration: 'Break Duration',
  breakLocation: 'Break Location',
  assignmentDetails: 'Assignment Details',
  hour: 'hour',
  description: 'Description',
  deleteAssignment: 'Delete Assignment',
  busyDriver: 'Busy',
  // VSER-14978: the day before's shift running past midnight
  continuesFrom: 'Continues from {0}',
  openDay: 'Open {0}',
  // VSER-14525: the dialogs of an edit or delete; every rule text itself comes from the server
  change: {
    checking: 'Checking the change…',
    applying: 'Applying the change. This can take up to a minute, please keep this page open.',
    scopeTitle: 'Which days should this change apply to?',
    goToPlanning: 'Go to Planning',
    edit: 'Edit',
    delete: 'Delete',
    deleteAndContinue: 'Delete and continue',
    deleteQuestion: 'Are you sure you want to delete this assignment?',
    blockedFallback: 'This change cannot be applied.',
    resultTitle: 'Result',
    rider: 'Rider',
    time: 'Time',
    previousVehicle: 'Previous Vehicle',
    outcome: 'Result',
    failedCount: '{0} not processed',
    timedOut:
      'The change is taking longer than expected and is still being processed. The day will be reloaded, please check the assignment before trying again.',
    genericError: 'The change could not be applied. Please try again.',
    saved: 'Assignment updated.',
    deleted: 'Assignment deleted.',
    // a moved ride's new pickup, minutes later or earlier
    minutes: '{0} min',
    // why a running shift's scope question leaves today out
    todayLeftOut: {
      edit:
        "Today's shift is in progress, so this change can only apply from tomorrow on. For today, only the end time, the break and the description can be changed here; to change today's driver, use the Planning page.",
      delete:
        "Today's shift is in progress and has assigned rides, so it can only be deleted from tomorrow on. To transfer today's rides or cancel the route, use the Planning page.",
    },
  },
};
